/**
 * PolymarketCard - Polymarket 匹配卡片
 */

import type { PolymarketMatch } from '../api/events'
import { triggerPolymarketClick } from './AnalyticsTracker'
import { useLanguage } from '../hooks/useLanguage'

interface PolymarketCardProps {
  match: PolymarketMatch
}

export function PolymarketCard({ match }: PolymarketCardProps) {
  const { t } = useLanguage()
  // 置信度颜色
  const confidenceColor = match.confidence >= 0.7
    ? 'bg-green-100 text-green-800'
    : match.confidence >= 0.5
    ? 'bg-yellow-100 text-yellow-800'
    : 'bg-gray-100 text-gray-800'

  // 点击时触发埋点
  const handleClick = () => {
    triggerPolymarketClick()
  }

  return (
    <a
      href={match.url || '#'}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="block bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-3 hover:shadow-md transition-shadow"
    >
      {/* 标题 */}
      <p className="font-medium text-sm mb-2 line-clamp-2">
        {match.market_title || 'Untitled Market'}
      </p>

      {/* 置信度 */}
      <div className="flex items-center gap-2">
        <span className={`px-2 py-0.5 text-xs font-medium rounded ${confidenceColor}`}>
          {Math.round(match.confidence * 100)}% {t('匹配', 'Match')}
        </span>
      </div>

      {/* 原因 */}
      {match.reason && (
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-2 line-clamp-2">
          {match.reason}
        </p>
      )}
    </a>
  )
}
